export default __webpack_public_path__ + "static/media/maisha.9b14fca4.jpg";